import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { MinimalSubscription } from "../../../pages/subscription-detail/types";
import { openDialogIncident } from "../../dialogs/dialog-incident/dialog-incident";

@Component({
  selector: "report-incident",
  templateUrl: "report-incident.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class ReportIncident {
  subscription = input.required<MinimalSubscription>();
  dialog = inject(MatDialog);

  openIncidentDialog(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    openDialogIncident(this.dialog, this.subscription());
    return false;
  }
}
